
import RichText from '~/patterns/molecules/rich-text/rich-text.vue';
import ImageSingle from '~/patterns/atoms/image-single/image-single.vue';

export default {
    components: {
        RichText,
        ImageSingle
    },

    props: {
        float: {
            type: Boolean,
            default: true
        },
        image: {
            type: Object,
            required: false,
            default: () => { return {}; }
        },
        richText: {
            type: String,
            required: false,
            default: ''
        },
        caption: {
            type: String,
            required: false,
            default: ''
        },
        imageAlignment: {
            type: String,
            default: 'right'
        },
        imageFit: {
            type: String,
            default: 'cover'
        }
    }
};
